import { ContractService } from './contract/contract.service';
import { CrmContactService } from './crm-contact/crm-contact.service';
import { EngineerService } from './engineer/engineer.service';
import { JobAreaService } from './job-area/job-area.service';
import { JobBlobConfigurationService } from './job-blob-configuration/job-blob-configuration.service';
import { JobCategoryService } from './job-category/job-category.service';
import { JobIssueService } from './job-issue/job-issue.service';
import { JobService } from './job/job.service';
import { JobStatusService } from './job-status/job-status.service';
import { JobTypeService } from './job-type/job-type.service';
import { MproDefService } from './mpro-def/mpro-def.service';
import { InvoiceLineTypeService } from './invoice-line-type/invoice-line-type.service';
import { PartStatusService } from './part-status/part-status.service';
import { SlaService } from './sla/sla.service';
import { ProductService } from './product/product.service';
import { VendorService } from './vendor/vendor.service';
import { TimesheetTypeService } from './timesheet-type/timesheet-type.service';
import { JobNoteTypeService } from './job-note-type/job-note-type.service';
import { AxPartService } from './ax-part/ax-part.service';
import { CustomerService } from './customer/customer.service';
import { SiteService } from './site/site.service';
import { LocationService } from './location/location.service';
import { SubLocationService } from './sub-location/sub-location.service';
import { TeamService } from './team/team.service';
import { MediaService } from './media/media.service';
import { DocStoreService } from './doc-store/doc-store.service';
import { ExpenseTypeService } from './expense-type/expense-type.service';
import { UserSettingProfileService } from './user-setting-profile/user-setting-profile.service';
import { QxFormService } from './qx-form/qx-form.service';
import { AxAssetService } from './ax-asset/ax-asset.service';
import { AxAssetStatusService } from './ax-asset-status/ax-asset-status-service';
import { QxAuditService } from './qx-audit/qx-audit.service';
import { QxQuestionTypeService } from './qx-question-type/qx-question-type.service';
import { TaskCategoryService } from './task-category/task-category.service';
import { WebReportService } from './web-reports/web-reports.service';
import { WebUserService } from './web-user/web-user.service';
import { PermissionAssetGroupService } from './permission-asset-group/permission-asset-group.service';
import { PermissionCrmContactGroupService } from './permission-crm-contact-group/permission-crm-contact-group.service';
import { PermissionJobGroupService } from './permission-job-group/permission-job-group.service';
import { PermissionSystemGroupService } from './permission-system-group/permission-system-group.service';
import { WebUserPermissionService } from './web-user-permission/web-user-permission.service';
import { PermissionGroupService } from './permission-group/permission-group.service';

export const ApiService = {
  AxAssetService,
  AxAssetStatusService,
  ContractService,
  CrmContactService,
  JobIssueService,
  JobCategoryService,
  JobAreaService,
  JobBlobConfigurationService,
  JobStatusService,
  JobTypeService,
  EngineerService,
  JobService,
  MproDefService,
  InvoiceLineTypeService,
  PartStatusService,
  QxFormService,
  QxQuestionTypeService,
  SlaService,
  TaskCategoryService,
  ProductService,
  VendorService,
  TimesheetTypeService,
  JobNoteTypeService,
  AxPartService,
  CustomerService,
  SiteService,
  LocationService,
  SubLocationService,
  TeamService,
  MediaService,
  DocStoreService,
  ExpenseTypeService,
  QxAuditService,
  UserSettingProfileService,
  WebReportService,
  WebUserService,
  PermissionAssetGroupService,
  PermissionCrmContactGroupService,
  PermissionJobGroupService,
  PermissionSystemGroupService,
  WebUserPermissionService,
  PermissionGroupService
};
